import { FC } from "react";
import {
  FaqAccordionLinkType,
  i18translateType,
} from "../../@types/types-body";
import { useTranslation } from "next-i18next";

export const FaqAccordionLink: FC<FaqAccordionLinkType> = ({
  id,
  namespace,
  title,
  text,
  isActive,
  setActive,
}) => {
  const { t }: i18translateType = useTranslation(namespace);
  return (
    <>
      <h2
        key={`accordion-collapse-heading-${id}`}
        id={`accordion-collapse-heading-${id}`}
      >
        <button
          type="button"
          className="flex items-center bg-white border-t-2 border-crowlyn
                        items-center justify-start w-full p-5 font-medium
                        text-left focus:ring-4
                        hover:bg-crowlyn-light text-gray-900"
          data-accordion-target="#accordion-collapse-body-1"
          aria-expanded="true"
          aria-controls="accordion-collapse-body-1"
          onClick={() => setActive(`accordion-collapse-body-${id}`)}
        >
          {isActive === `accordion-collapse-body-${id}` ? (
            <svg
              className="w-6 h-6 rotate-180 shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
            </svg>
          ) : (
            <svg
              className="w-6 h-6 rotate-180 shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" />
            </svg>
          )}
          <span className=" ml-4 leading-6 align-text-bottom">
            {t(`${title}`)}
          </span>
        </button>
      </h2>
      <div
        id={`accordion-collapse-body-${id}`}
        className={isActive === `accordion-collapse-body-${id}` ? "" : "hidden"}
        aria-labelledby={`accordion-collapse-body-${id}`}
      >
        <div className="p-5 font-light ">
          <p className="mb-2 text-gray-900">{t(`${text}`)}</p>
        </div>
      </div>
    </>
  );
};
